// Your application will be accessible at:
//   Production: https://auth.innerlogic-api.com
//   Staging: https://stg-auth.innerlogic-api.com

// go auth login 
// export const goAuthApiServer = 'https://auth.innerlogic.com'
// export const goAuthApiStaging = 'https://stg-auth-api.innerlogic.ca'

export const goAuthApiServer = 'https://auth.innerlogic-api.com'
export const goAuthApiStaging = 'https://stg-auth.innerlogic-api.com'

export const goAuthApiLocal = 'http://0.0.0.0:8080'

// app urls
// export const serverApi = 'https://api2.innerlogic.com'
export const serverApi = 'https://django-api.innerlogic-api.com'
// export const staginApi = 'https://stg-api.innerlogic.ca'
export const staginApi = 'https://stg-django-api.innerlogic-api.com'
export const localApi = 'http://127.0.0.1:8000'

// PRocess URL
export const processApiServer = 'https://chat-process.innerlogic.ca'
export const processApiStaging = 'https://stg-chat-process.innerlogic.ca'
export const processApiLocal = 'http://127.0.0.1:9000'
// 
//report api
export const reportProductionApi = "https://reports-api.innerlogic.ca"
export const reportStagingApi = "https://stg-reports-api.innerlogic.ca"
export const reportLocalApi = "http://127.0.0.1:9000"

// Devops url
export const devopsApi = 'https://devops-api.innerlogic.ca'
export const devopsStagingApi = 'https://stg-devops-api.innerlogic.ca'
export const devopsLocal = 'http://127.0.0.1:9000'

const stagingDevopsToken = 'bdf7c21a-9079-4873-b095-ebf1a6691a51'
// const productionDevopsToken = '5e0579d6-da41-4c09-8891-ad3b3ee983ad' 
// const localDevopsToken = "4468a"

export const serverUrl = "https://stg-admin.innerlogic.com"
export const Domain = ''

// Publishable key
export const Environment = 'Development'
export const SentryDSN_DEV = "" 
// export const SentryDSN_PROD = "https://53de57189a184c5db40d1d7ea9394a96@o1167548.ingest.sentry.io/6258716"
// export const SentryDSN_STG = "https://40343aed15d841c6b882b632552007ee@o1167548.ingest.sentry.io/6258777"

export const CreateDemoResponses = true

export const StripeKey = 'pk_test_bowWtykmtAwZxvD0bvdXEycG00LczLxeDB'

// // to use production uncomment these lines
// export const currentApi = serverApi
// export const curGoApi = goAuthApiServer
// export const reportApi = reportProductionApi
// export const curProcessUrl = processApiServer
// export const curDevopsApi = devopsApi
// export const curDevopsToken = productionDevopsToken


// to use staging uncomment these lines
export const curGoApi = goAuthApiStaging
export const currentApi = staginApi 
export const curProcessUrl = processApiStaging
export const reportApi = reportStagingApi
export const curDevopsApi = devopsStagingApi
export const curDevopsToken = stagingDevopsToken

// // to use local uncomment these lines
// export const curGoApi = goAuthApiLocal
// export const currentApi = localApi
// export const reportApi = reportLocalApi
// export const curProcessUrl = processApiLocal
// export const curDevopsApi = devopsLocal
// export const curDevopsToken = localDevopsToken

export const config = {
    // switch to go for login
    loginapi: `${curGoApi}`,
    // use django api for login changed Oct 3 2022
    // loginapi: `${currentApi}/api/account`,
    // signupapi: `${currentApi}/api/signup`,
    // authapi: `${currentApi}/api/rest-auth`,
    // surveyapi: `${currentApi}/api/survey`,
    devopsApi: `${curDevopsApi}`,
    reportApi,
    portalapi: `${currentApi}/api/organization`,
    appapi: `${currentApi}/api/support`,
    clearCache: `${currentApi}/clear-cache/`,
    aiProcessUrl: `${curProcessUrl}`,
};
export default config

// npx browserslist@latest --update-db
// go-auth-api.innerlogic.ca
// go-trainwave-api.innerlogic.ca


// # LOCAL 'http://127.0.0.1:9000'
// # PROCESS_URL='http://127.0.0.1:9000'
